<!--
 * @Descripttion: 项目根组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-09-01 14:34:14
--> 

<template>
  <div id="app" name="app">
    <el-container>
      <!-- 顶栏容器 -->

      <el-header v-show="$route.meta.showMenu!==false" style="background-color:#5a4b6c;border-bottom:0;box-shadow:0 0px 0 #5a4b6c;">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#ffb2c8"
          background-color="#5a4b6c"
          text-color="#ffffff"
          router
          style="border-bottom:0;box-shadow:0 0px 0 #5a4b6c;"
        >
          <div class="logo">
            <router-link to="/">
              <img src="./assets/imgs/clogo.png" alt />
            </router-link>
          </div>
          <el-menu-item index="/">Home</el-menu-item>
          <el-menu-item index="/about">About Me</el-menu-item>
          <el-submenu index="shop">
            <template slot="title">Shop Now</template>
            <el-menu-item
              v-for="item in shopCategories"
              :key="item.category_id"
              :index="`/goods?categoryID=${item.category_id}`"
            >
              {{item.category_name}}
            </el-menu-item>
          </el-submenu>
          <el-submenu index="faqs">
            <template slot="title">FAQs</template>
            <el-menu-item index="/faqs?section=shopping">Shopping Information</el-menu-item>
            <el-menu-item index="/faqs?section=returns">Return &amp; Cancellation</el-menu-item>
          </el-submenu>
          <el-menu-item index="/contact">Contact Us</el-menu-item>
<!--          <a href="https://congz666.gitee.io/" target="_blank">-->
<!--            <el-menu-item :index="0">个人博客</el-menu-item>-->
<!--          </a>-->
          <div class="menu-right">
            <div v-if="!this.$store.getters.getUser" class="menu-auth-wrap">
              <div class="menu-auth-trigger">
                <router-link to="/login">Login</router-link>
                <span>/</span>
                <router-link to="/register">Register</router-link>
              </div>
              <div class="menu-auth-panel">
                <div class="auth-tabs">
                  <span class="active">Sign in</span>
                  <router-link to="/register">Create an Account</router-link>
                </div>
                <div class="auth-field">Username or email address</div>
                <el-input size="mini" placeholder="Username or email address"></el-input>
                <div class="auth-field">Password</div>
                <el-input size="mini" type="password" placeholder="Password"></el-input>
                <el-button size="mini" type="primary" class="auth-submit">Log In</el-button>
                <div class="auth-footer">
                  <label><input type="checkbox" /> Remember me</label>
                  <router-link to="/login">Lost your password?</router-link>
                </div>
              </div>
            </div>
            <div v-else class="header-user-con">
              <div class="user-avator">
                <img :src="this.$store.getters.getUser.avatar" />
              </div>
              <div class="user-name">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    {{this.$store.getters.getUser.nickname}}
                    <i class="el-icon-caret-bottom"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <router-link to="/center">
                      <el-dropdown-item>Personal Center</el-dropdown-item>
                    </router-link>
                    <a @click="logout">
                      <el-dropdown-item>Logout</el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <router-link class="menu-text" to="/favorite">Wishlist</router-link>
            <router-link :class="getNum > 0 ? 'menu-cart menu-cart-full' : 'menu-cart'" to="/cart">
              Cart
              <span>{{getNum}}</span>
            </router-link>
            <router-link class="menu-text" to="/goods">Search</router-link>
          </div>
        </el-menu>
      </el-header>

      <!-- 顶栏容器END -->

      <!-- 主要区域容器 -->
      <el-main>
        <keep-alive>
          <router-view :key="key"></router-view>
        </keep-alive>
      </el-main>
      <!-- 主要区域容器END -->

      <!-- 底栏容器 -->
      <el-footer>
        <div class="footer">
          <div class="footer-badges">
            <div class="footer-badge">Secure Payments</div>
            <div class="footer-badge">Easy Returns</div>
            <div class="footer-badge">Festival Sale Live</div>
            <div class="footer-badge">Cash on Delivery Available</div>
          </div>
          <div class="footer-main">
            <div class="footer-col footer-about">
              <h4>About Us</h4>
              <p>Twinnrshop is a trusted fashion brand offering high-quality ethnic and fusion wear at affordable prices.</p>
              <p>From sarees and kurtis to blouses and dupattas, our curated collection is designed for comfort, style, and everyday elegance.</p>
            </div>
            <div class="footer-col footer-contact">
              <h4>Contact</h4>
              <p>Superpark976@gmail.com</p>
              <p>+91 8311855933</p>
              <p>Unit No. 0309, Tower B, Logix Techno Sector 132, Noida, UP 201304</p>
            </div>
            <div class="footer-col footer-links">
              <h4>Useful URL</h4>
              <router-link to="/">Home</router-link>
              <router-link to="/about">About Me</router-link>
              <router-link to="/goods">Shop</router-link>
              <router-link to="/about?id=6">Terms & Conditions</router-link>
              <router-link to="/order">Order Tracking</router-link>
            </div>
            <div class="footer-col footer-policy">
              <h4>Privacy URL</h4>
              <router-link to="/about?id=2">Privacy Policy</router-link>
              <router-link to="/about?id=6">Terms and Conditions</router-link>
              <router-link to="/about?id=4">Refund Policy</router-link>
              <router-link to="/about?id=5">Cancellation Policy</router-link>
              <router-link to="/about?id=3">Shipping Policy</router-link>
            </div>
          </div>
          <div class="footer-bottom">Copyright © 2025, SuperShop by Superpark Private Limited All Rights Reserved</div>
        </div>
      </el-footer>
      <!-- 底栏容器END -->
    </el-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import * as cartsAPI from '@/api/carts'
import * as userAPI from '@/api/users'
import * as categoryAPI from '@/api/categories'

export default {
  beforeUpdate() {
    this.activeIndex = this.$route.path
  },
  data() {
    return {
      activeIndex: '', // 头部导航栏选中的标签
      search: '', // 搜索条件
      shopCategories: []
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#f5f5f5')
  },
  created() {
    // 获取浏览器localStorage，判断用户是否已经登录
    userAPI.checkToken(localStorage.getItem('token')).then(res => {
      // 如果已经登录，设置vuex登录状态
      if (res.status == 200) {
        this.setUser(JSON.parse(localStorage.getItem('user')))
      } else {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
      }
    })
    categoryAPI
      .listCategories()
      .then(res => {
        if (res.status === 200) {
          this.shopCategories = res.data
        } else {
          this.notifyError('Failed to obtain classification', res.msg)
        }
      })
      .catch(err => {
        this.notifyError('Failed to obtain classification', err)
      })
  },
  computed: {
    ...mapGetters(['getUser', 'getNum']),
    key() {
      return this.$route.path + Math.random()
    }
  },
  watch: {
    // 获取vuex的登录状态
    getUser: function(val) {
      if (val === '') {
        // 用户没有登录
        this.setShoppingCart([])
      } else {
        // 用户已经登录,获取该用户的购物车信息
        cartsAPI
          .showCarts(val.id)
          .then(res => {
            if (res.status === 200) {
              if (res.data === null) {
                this.setShoppingCart([])
              } else {
                this.setShoppingCart(res.data)
              }
            } else if (res.status === 20001) {
              //token过期，需要重新登录
              this.loginExpired(res.msg)
            } else {
              this.$notify.error({
                title: '购物车获取失败',
                message: res.msg
              })
            }
          })
          .catch(err => {
            return Promise.reject(err)
          })
      }
    }
  },
  methods: {
    ...mapActions(['setUser', 'setShoppingCart']),
    login() {
      this.$router.push({
        name: 'Login'
      })
    },
    // 退出登录
    logout() {
      // 清空本地登录信息
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      // 清空vuex登录信息
      this.setUser('')
      this.$router.push({
        name: 'Home'
      })
      this.notifySucceed('登出成功')
    },
    //重定向
    register() {
      this.$router.push({
        name: 'Register'
      })
    },
    // 点击搜索按钮
    searchClick() {
      if (this.search != '') {
        // 跳转到全部商品页面,并传递搜索条件
        this.$router.push({ path: '/goods', query: { search: this.search } })
        this.search = ''
      }
    }
  }
}
</script>

<style>
/* 全局CSS */
* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;
}

.header-user-con {
  display: flex;
  height: 44px;
  align-items: center;
}
.user-name {
  margin-left: 10px;
}
.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}

.el-dropdown-menu__item {
  text-align: center;
}
.el-dropdown-item:hover {
  color: #ff6700;
}

#app .el-header {
  padding: 0;
}
#app .el-main {
  min-height: 300px;
  padding: 0;
  overflow: visible;
}
#app .el-footer {
  padding: 0;
}
a,
a:hover {
  text-decoration: none;
}
/* 全局CSS END */

/* 顶部导航栏CSS */
/* 顶栏容器CSS */
.el-header {
  margin-bottom: 0;
  background-color: #5a4b6c;
  border-bottom: 0;
}
.el-header .el-menu {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: transparent;
  flex-wrap: nowrap;
  border-bottom: 0;
}
.el-menu--horizontal {
  border-bottom: 0;
}
.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu .el-submenu__title {
  border-bottom: 0;
}

.el-header .logo {
  height: 60px;
  width: 100px;
  float: left;
  margin-right: 40px;
  flex-shrink: 0;
}
.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu {
  flex-shrink: 0;
}
.el-header .logo img {
  height: 52px;
  margin-top: 4px;
}
.menu-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #ffffff;
  flex-shrink: 0;
}
.menu-auth-wrap {
  position: relative;
}
.menu-auth-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #ffffff;
  white-space: nowrap;
}
.menu-auth-trigger a {
  color: #ffffff;
}
.menu-auth-panel {
  position: absolute;
  right: 0;
  top: 34px;
  width: 270px;
  background: #ffffff;
  color: #2f2238;
  border-radius: 6px;
  padding: 14px;
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.18);
  display: none;
  z-index: 10;
}
.menu-auth-wrap:hover .menu-auth-panel {
  display: block;
}
.auth-tabs {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 10px;
}
.auth-tabs .active {
  font-weight: 600;
  color: #2f2238;
}
.auth-tabs a {
  color: #6d637b;
}
.auth-field {
  font-size: 11px;
  color: #6d637b;
  margin: 8px 0 4px;
}
.auth-submit {
  margin-top: 10px;
  width: 100%;
  background: #5a4b6c;
  border-color: #5a4b6c;
}
.auth-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: #6d637b;
  margin-top: 10px;
}
.auth-footer a {
  color: #6d637b;
}
.auth-footer input {
  margin-right: 6px;
}
.menu-text {
  color: #ffffff;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.menu-cart {
  color: #ffffff;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 14px;
  font-size: 12px;
  letter-spacing: 0.2px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.menu-cart-full {
  background: #ff5f8f;
  color: #ffffff;
}
.el-menu--horizontal > .el-menu-item {
  color: #ffffff;
  font-weight: 600;
  letter-spacing: 0.4px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: #ff5f8f;
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  color: #ffb2c8;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #ffffff;
  font-weight: 600;
  letter-spacing: 0.4px;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: #ff5f8f;
}
.el-menu--horizontal > .el-submenu:not(.is-disabled):hover .el-submenu__title {
  color: #ffb2c8;
}
.el-input-group__append {
  background-color: #ffffff;
  border-color: #ffffff;
}
.el-input__inner {
  border-radius: 18px 0 0 18px;
}
.el-input-group__append .el-button {
  border-radius: 0 18px 18px 0;
}
/* 顶栏容器CSS END */

/* 底栏容器CSS */
.footer {
  width: 100%;
  background: #5a4b6c;
  color: #ffffff;
  padding: 24px 0 16px;
}
.footer-badges {
  max-width: 1225px;
  margin: 0 auto 24px;
  background: #0f0f14;
  color: #ffffff;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 10px 18px;
  border-radius: 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.footer-badge {
  text-align: center;
}
.footer-main {
  max-width: 1225px;
  margin: 0 auto 16px;
  display: grid;
  grid-template-columns: 2.2fr 1.4fr 1fr 1fr;
  gap: 24px;
}
.footer-col h4 {
  font-size: 14px;
  margin-bottom: 12px;
  letter-spacing: 0.4px;
}
.footer-col p {
  font-size: 12px;
  line-height: 1.7;
  color: #e6e1ee;
  margin-bottom: 8px;
}
.footer-col a {
  display: block;
  color: #e6e1ee;
  font-size: 12px;
  margin-bottom: 8px;
}
.footer-col a:hover {
  color: #ffb2c8;
}
.footer-bottom {
  text-align: center;
  font-size: 12px;
  color: #e6e1ee;
}
/* 底栏容器CSS END */
</style>
